/**
 * For a given hash, open the corresponding <details> element if it exists.
 *
 * e.g. Given `#buffalo`, find a target <details> element. If found, open the
 * details element.
 *
 * @param {string} hash Example: #buffalo
 * @returns void
 */
export const handleHash = (hash: string): void => {
  if (!hash) {
    return;
  }

  let target = document.querySelector(hash);

  if (!target) {
    return;
  }

  if (!(target instanceof HTMLDetailsElement)) {
    target = target.closest("details");
  }

  if (!(target instanceof HTMLDetailsElement)) {
    return;
  }

  target.open = true;
};

/**
 * Register event listeners for handling hashes.
 *
 * @returns void
 */
const init = (): void => {
  window.addEventListener("load", (): void => {
    handleHash(window.location.hash);
  });

  document.addEventListener("click", (event: Event): void => {
    if (!(event.target instanceof HTMLElement)) {
      return;
    }

    const target = event.target.closest("a");

    if (!(target instanceof HTMLAnchorElement)) {
      return;
    }

    handleHash(target.hash);
  });
};

export default init();
